import Icon from "@material-ui/icons/Person";
import BusSchedulesCreate from "./BusSchedulesCreate";
import BusSchedulesEdit from "./BusSchedulesEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "busSchedules",
  edit: BusSchedulesEdit,
  create: BusSchedulesCreate,
  icon: Icon,
};
